import React, { useState, useEffect } from 'react'
import { Link, withRouter } from 'react-router-dom'
import navbarData from '../../../cms-data/navbar.json'
import styles from './Navbar.module.scss'

const Navbar= ({ sidebarShow, toggleSideBar, location, isSubdomain }) => {

    const { navbarLogo: { navbarLogo, navbarScrolledLogo },
        navbarLinks, signupButton: { signupButtonName, signupButtonLink }, loginButton: { loginButtonName, loginButtonLink } }= navbarData

    const path= location.pathname
    const [scrolled, setScrolled]= useState()
    const [mobileProductDropdownShow, setMobileProductDropdownShow]= useState(false)
    const [activeDropdownIndex, setActiveDropdownIndex]= useState('')
    let lastScroll= 0

    const handleScroll=() => {
        const offset=window.scrollY;
        // offset > 80 && offset<lastScroll
        if(offset > 100){
            setScrolled(true);
        }
        else{
            setScrolled(false);
        }
        lastScroll= offset
    }

    useEffect(() => {
        window.addEventListener('scroll',handleScroll)
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    const industriesDropdownToggleHandler= (e, index) => {
        e.stopPropagation()
        setMobileProductDropdownShow(!mobileProductDropdownShow)
        setActiveDropdownIndex(index)
    }

    const createLink= (link) => {

        const absoluteDomain= 'https://razorthink.com'
        return isSubdomain ? `${absoluteDomain}${link}`: link
    }

    const absoluteLink = ["Help Center"];
return (
<div className={`${styles.navbar}  ${scrolled && styles.scrolled}`}>
    <div className={styles.container}>
        <div className={styles.logo}>
            <a className={styles.logoLink} href={'/'}>
                <img alt='rzt-logo' className={styles.logoImg} src={`${!scrolled ? navbarLogo.split('/public')[1]: navbarScrolledLogo.split('/public')[1]}`} />
            </a>
          {isSubdomain && <a href={`/`}>HELP CENTER</a>}
        </div>
        <div className={styles.navLinksContainer}>
            <ul className={`${styles.navLinks} ${scrolled && styles.scrolled}`}>
                {
                    navbarLinks.map((navbarLink, index ) => {
                        const { navbarTitle, link }= navbarLink
                        let { navBarSubMenu }= navbarLink
                        if(isSubdomain && navBarSubMenu) {
                            navBarSubMenu= navBarSubMenu.filter(menu => menu.title!=='Support')
                        }
                        return (
                            <div>
                                {/*<li key={index} className={`${styles.navLink} ${link===path && styles.highlightedPath}`}><Link to={link}>{navbarTitle}</Link></li>*/}
                                <li key={index} className={`${styles.navLink} ${link===path && styles.highlightedPath}`}>{ link ?
                                    isSubdomain ? <a href={createLink(link)}>{navbarTitle}</a> : <Link to={link}>{navbarTitle}</Link> :
                                    <><div className={`${styles.navLink} ${styles.industriesDropdown}`}>
                                        <button className={`${styles.dropButton} ${path.includes('industries') && styles.highlightedPath}`}>{navbarTitle}
                                            <span className={styles.dropdownCaret}>
                                            <svg  className='bi bi-caret-down-fill' xmlns="http://www.w3.org/2000/svg" width="12" height="10" fill="currentColor"
                                                  viewBox="0 0 16 16">
                                            <path
                                                d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                            </svg>
                                        </span>
                                        </button>
                                        <div className={styles.dropdownContent}>
                                            {navBarSubMenu.map((subMenu, index) => {
                                                return(
                                                    isSubdomain && subMenu.title!=='Helpdoc'  ?
                                                    <a href={createLink(subMenu.link)}>{subMenu.title}</a> : absoluteLink.includes(subMenu.title) ? <a href={(subMenu.link)} target='_blank'>{subMenu.title}</a> : <Link key={index} to={subMenu.link}>{subMenu.title}</Link>
                                                )
                                            })}
                                        </div>
                                    </div></>
                                }</li>
                            </div>
                        )
                    })
                }

                {/*<a href={`${loginButtonLink}`} className={styles.navLink}><li className={styles.loginButton}>{loginButtonName}</li></a>*/}
                {/*{isSubdomain ? <a href={createLink(signupButtonLink)} className={styles.navLink}><li className={styles.signUpButton}>{signupButtonName}</li></a>*/}
                {/*: <Link className={styles.navLink} to={signupButtonLink}><li className={styles.signUpButton}>{signupButtonName}</li></Link>}*/}
            </ul>
        </div>
        <div className={styles.hamburgerMenu} onClick={()=>toggleSideBar(!sidebarShow)}>
            <img alt='menu' src={`${!scrolled ? '/img/homepage/menu.svg': '/img/homepage/menu-black.svg'}`}/>
        </div>
    </div>
    <div className={`${styles.sidebarMenu} ${sidebarShow && styles.showSidebarAnimation}`}>
        <div className={styles.container}>
            <div className={styles.closeButton} onClick={()=>toggleSideBar(!sidebarShow)}>
                <img alt='close' src={'/img/homepage/close.svg'} />
            </div>
            <div className={styles.navLinks}>
                <ul>
                    <li className={styles.mobileLink} onClick={()=>{ toggleSideBar(false)}}><Link to='/'>Home</Link></li>
                    {
                        navbarLinks.map((navbarLink, index) => {
                            const { navbarTitle, link, navBarSubMenu }= navbarLink
                            return (
                                // <li key={index} className={styles.mobileLink} onClick={()=>{ toggleSideBar(false)}}><Link to={link}>{navbarTitle}</Link></li>
                                <li key={index} className={styles.mobileLink} onClick={()=>{link && toggleSideBar(false)}}> { link ?
                                    <Link to={link}>{navbarTitle}</Link> :
                                    <> <div className={styles.industriesDropdown} onClick={(e) =>industriesDropdownToggleHandler(e, index)}>
                                        <button className={styles.dropButton}>{navbarTitle}
                                            <img className={styles.dropdownCaret} alt='caret' src='/img/homepage/dropdown.svg' />
                                        </button>
                                        <div className={`${mobileProductDropdownShow ? styles.showDropdown : null} ${styles.dropdownContent}`}>
                                            {activeDropdownIndex===index &&
                                            navbarLinks[activeDropdownIndex].navBarSubMenu.map((subMenu, index) => {
                                                return(
                                                    <li onClick={()=>{ toggleSideBar(false)}}>
                                                        <Link key={index} to={subMenu.link}>{subMenu.title}</Link>
                                                    </li>
                                                )
                                            })}
                                        </div>
                                    </div> </>
                                } </li>
                            )
                        })
                    }
                </ul>
            </div>
            <div className={styles.getStarted}>
                <div className={styles.header}>
                    Get started today
                </div>
                <div className={styles.info}>
                    Are you ready to experience the power and simplicity of market proven AI Products?
                </div>
                <div className={styles.requestButton}>
                   <Link to='/register'>
                        <button onClick={()=>{ toggleSideBar(false)}}>REQUEST A DEMO</button>
                    </Link>
                </div>
            </div>
        </div>
    </div>
</div>
)
}

            export default withRouter(Navbar)
